import { portfolioAbilityResolvers } from "portfolio/constants/abilityResolvers.constants";

export type AbilityResolver = () => Promise<boolean>;

/**
 * Central registry of ability resolvers.
 * Each domain registers its own resolvers here.
 * The router guard uses this to check abilities defined in route meta.
 */
export const abilityResolvers: Record<string, AbilityResolver> = {
  ...portfolioAbilityResolvers,
};
